import { FC, useEffect, useState } from 'react';

import { motion } from 'framer-motion';

import { StyledButton, StyledButtonGroup } from './styles';

// TODO/SB : We can make height as transient prop, since it is used for StyledComponents
interface ButtonGroupProps {
  labels: string[];
  initialActiveIndex?: number;
  selectedLabel?: string;
  selectedIndex?: number;
  onLabelChange?: (label: string) => void;
  onIndexChange?: (index: number) => void;
  onButtonClick?: (index: number) => void;
  height?: string;
  disabled?: boolean;
}
const RToggleButtons: FC<ButtonGroupProps> = ({
  labels,
  initialActiveIndex = 0,
  selectedLabel,
  selectedIndex,
  onButtonClick,
  onLabelChange,
  onIndexChange,
  height,
  disabled,
}) => {
  const [activeIndex, setActiveIndex] = useState(initialActiveIndex);

  useEffect(() => {
    if (typeof selectedIndex === 'number') {
      setActiveIndex(selectedIndex);
    } else if (selectedLabel) {
      const index = labels.indexOf(selectedLabel);
      if (index !== -1) {
        setActiveIndex(index);
      }
    }
  }, [selectedIndex, selectedLabel, labels]);

  const handleClick = (index: number) => {
    if (typeof selectedIndex !== 'number') {
      setActiveIndex(index);
    }
    if (onButtonClick) {
      onButtonClick(index);
    }
    if (onLabelChange) {
      onLabelChange(labels[index]);
    }
    if (onIndexChange) {
      onIndexChange(index);
    }
  };
  return (
    <StyledButtonGroup height={height}>
      {labels.map((labels, index) => (
        <motion.div key={index} whileTap={{ scale: 0.9 }}>
          <StyledButton
            disabled={disabled}
            key={index}
            $active={index === activeIndex}
            onClick={() => handleClick(index)}
          >
            {labels}
          </StyledButton>
        </motion.div>
      ))}
    </StyledButtonGroup>
  );
};
export default RToggleButtons;
